import React, { useState, useEffect } from "react";
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import dayjs from "dayjs";
import InputWrapper from "features/forms/components/InputWrapper";
import { updateLeadStatus } from "api/LeadApi";
import { OnlineLeadStatus, PATHS, personnelType } from "constants/Constants";
import InputElement, {
	SelectorElement,
} from "features/forms/components/InputElement";
import { getVehicleDetails } from "api/InventoryAPI";
import DeleteLeadButton from "../../helperFunctions/DeleteLeadButton.js";
import Experian from "assets/img/experianLogo.png";
import Equifax from "assets/img/equifaxLogo.png";
import Transunion from "assets/img/transUnionLogo.png";
import Credit from "assets/img/700CreditLogo2.png";
import { getLeadDealerNotes, saveLead } from "api/LeadApi";
import { FormProvider, useFormContext } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import * as yup from "yup";
import { getNotesArray } from "features/notes/NoteFunctions";
import NoteComponent from "features/notes/NoteComponent";
import PersonalData from "./PersonalData.js";
import MessageData from "./MessageData.js";
import VehicleData from "./VehicleData.js";
import LookingForData from "./LookingForData.js";
import ProfilePicture from "./ProfilePicture.js";
import PreScreenModals from "./PreScreenModals.js";
import { getMakeList, getModelList, getYearList } from "./onlineLeadUtils.js";
import { useFromPartnerLink } from "../../../../stores/LocalStorageHelper.js";
import { useHistory } from "react-router-dom";
import { object } from "prop-types";
import LiabilityTab from "../contactTabs/liabilityTab/LiabilityTab.js";
import ChildrenModal from "../../../../components/modals/ChildrenModal.js";
import { getLeadLiabilities } from "../../../../api/LiabilitiesApi.js";
import useUserPrivileges from "../../../settings/subFeatures/settingsTabs/userManagement/useUserPrivileges.js";
import { saveFailAlert } from "../../../../utils/alertUtils.js";
import LeadTradeInfo from "./LeadTradeInfo.js";
import { getPersonelList } from "../../../../api/LoginAPI.js";

const OnlineLeadDetails = ({
	lead = {},
	toggle = () => {},
	salesPeople = [],
	setLeadSource = () => {},
}) => {
	const [showNote, setShowNote] = useState(false);
	const NoteToggle = () => setShowNote(!showNote);
	const history = useHistory();
	const privileges = useUserPrivileges();
	// Lead store
	const dealerInfo = JSON.parse(sessionStorage.getItem("user"));
	const dealerID = dealerInfo.dealerID;
	const locationID = dealerInfo.locationID;
	const [currentLead, setCurrentLead] = useState(lead);

	const [yearList, editYearList] = useState([]);
	const [makeList, editMakeList] = useState([]);
	const [modelList, editModelList] = useState([]);
	//	const [colorList, editColorList] = useState([]);

	const [dealerNote, setDealerNote] = useState([]);
	const [leadNote, setLeadNote] = useState([]);
	const [leadVehicle, setLeadVehicle] = useState({});
	const [leadTrade, setLeadTrade] = useState({});
	const [status, setStatus] = useState(lead?.leadStatus || 0);
	const [incID, setIncID] = useState(lead?.inventoryID);

	const [tuModal, setTuModal] = useState(false);
	const [xpnModal, setXpnModal] = useState(false);
	const [efxModal, setEfxModal] = useState(false);
	const [liabilityModal, setLiabilityModal] = useState(false);
	const [liabilities, setLiabilities] = useState([]);

	const toggleLiability = () => {
		setLiabilityModal(!liabilityModal);
	};

	const [editModal, setEditModal] = useState(false);
	const toggleEdit = () => setEditModal(!editModal);

	const checkPermission = () => {
		const p = privileges();
		if (!p.pullCredit) {
			saveFailAlert("User does not have permission to pull credit");
			return false;
		} else return true;
	};

	const tuToggle = () => {
		if (!checkPermission()) return;
		setTuModal(!tuModal);
	};

	const xpnToggle = () => {
		if (!checkPermission()) return;
		setXpnModal(!xpnModal);
	};

	const efxToggle = () => {
		if (!checkPermission()) return;
		setEfxModal(!efxModal);
	};

	const isCreditSignup = useFromPartnerLink("isCreditSignup");

	const schema = yup.object().shape({
		year: yup
			.date()
			.max(new Date().getFullYear() + 1)
			.min(new Date("January 01, 1900 00:00:00").getFullYear())
			.nullable()
			.transform((curr, orig) => (orig?.length === 4 ? curr : null))
			.required("Required (YYYY)"),
	});

	const methods = useFormContext({
		reValidateMode: "onBlur",
		resolver: yupResolver(schema),
	});

	const today = dayjs().format("YYYY-MM-DD");
	const todayTime = dayjs().format("YYYY-MM-DDTHH:mm:ss");

	let defaultLead = {
		toLocationID: locationID,
		firstName: "",
		lastName: "",
		middleName: "",
		gender: "",
		businessName: "",
		workPhone: "",
		workPhoneExt: "",
		dob: "",
		phone: "",
		cellPhone: "",
		Website: "",
		email: "",
		unit: "",
		address: "",
		city: "",
		state: "",
		zipCode: "",
		country: "",
		dateGenerated: todayTime,
		dateRead: null,
		leadStatus: 0,
		leadOrigin: null,
		leadOriginName: "",
		message: "",
		dealerNotes: "",
		priceRange: "",
		year: "",
		make: "",
		model: "",
		trim: "",
		Color: "",
		stockNumber: "",
		inventoryID: null,
		customerID: null,
		salesPersonID: null,
		salesPerson2ID: null,
		source: "",
		lastSync: null,
		insertedOn: today,
		updatedOn: today,
		driverLicense: "",
		driverLicExpDate: null,
		createdBy: "",
		xpnScore: null,
		efxScore: null,
		tuScore: null,
		credit700Url: "",
	}; // Define rules for each input field
	const [handleNote, setHandleNote] = useState(false);
	const shouldSaveNote = () => setHandleNote(!handleNote);
	useEffect(() => {
		if (lead?.leadID) {
			saveNotes();
		}
		// eslint-disable-next-line
	}, [handleNote]);

	const handleChange = (name, value) => {
		if (name === "dealerNotes") {
			console.log(value);
			console.log(value.size);
		}
		setCurrentLead((prevLead) => ({
			...prevLead,
			[name]: value,
		}));
	};

	const htmlMessage = (currentLead?.message ?? "")
		.replace(
			/<a href=([^>]+)><b>([^<]+)<\/b><\/a>/g,
			(match, p1, p2) => `<a href="${p1}"><b>${p2}</b></a>`
		)
		.replace(/&amp;/g, "&")
		.replace(/&quot;/g, '"')
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">");

	const getLeadNotes = (leadID) => {
		getLeadDealerNotes(leadID).then(
			(res) => {
				console.log(res.data);
				console.log(res.data.content.DealerNotes);
				const container = res.data.content.DealerNotes.map((obj) => {
					console.log(obj);
					const note = (
						<>
							<div>
								{dayjs(obj.createdOn).format("MM/DD/YYYY HH:MM") +
									" " +
									obj.description}
							</div>
						</>
					);
					return note;
				});

				setLeadNote(container);
			},
			(err) => {
				console.log(err);
			}
		);
	};

	const saveNotes = () => {
		let tempNote = Array.isArray(dealerNote)
			? JSON.stringify(dealerNote)
			: [{ description: dealerNote }];
		//setDealerNote(dealerNote);
		handleChange("dealerNotes", tempNote);
		let l = { ...currentLead, dealerNotes: tempNote };
		saveLead(l).then((res) => {
			if (l.leadID == null) {
				setLeadSource((prev) => {
					return [res.data.content, ...prev];
				});
			} else {
				setLeadSource((prev) => {
					return prev.map((row) => (row.leadID === l.leadID ? l : row));
				});
			}
		});
	};

	const getVehicleData = (inventoryID) => {
		inventoryID != null &&
			getVehicleDetails(inventoryID).then(
				(res) => {
					console.log(res.data.content);
					setLeadVehicle(res.data.content);
				},
				(err) => {
					console.log(err);
				}
			);
	};

	const scoreHandler = (score) => {
		if (score === null || score === undefined) {
			return "None";
		} else if (score >= 0) {
			return score;
		} else {
			return "None";
		}
	};

	useEffect(() => {
		getYearList({ editYearList });
		getMakeList({ editMakeList });
		if (lead && lead?.leadID) {
			getLeadNotes(lead?.leadID);
			setDealerNote(getNotesArray(lead?.dealerNotes));
			setIncID(lead?.inventoryID);
			getLeadLiabilities(lead?.leadID).then(
				(res) => {
					console.log(res);
					setLiabilities(res.data.content);
				},
				(err) => {
					console.log(err);
				}
			);
		} else {
			setCurrentLead(defaultLead);
		}
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		getModelList({ editModelList });
		// eslint-disable-next-line
	}, [lead.make]);

	useEffect(() => {
		getVehicleData(incID);
		handleChange("inventoryID", incID);
		// eslint-disable-next-line
	}, [incID]);

	useEffect(() => {
		setDealerNote(getNotesArray(lead?.dealerNotes));
		// eslint-disable-next-line
	}, [lead?.dealerNotes]);

	useEffect(() => {
		if (lead?.leadID !== null) {
			updateLeadStatus(lead?.leadID, status);
		}
		handleChange("leadStatus", status);

		// eslint-disable-next-line
	}, [status]);

	const LeadSaveButton = () => {
		return (
			<>
				<div
					className="btn btn-success float-button"
					onClick={() => {
						let l = { ...currentLead };
						if (currentLead.leadID == null) {
							let tempNote = Array.isArray(dealerNote)
								? JSON.stringify(dealerNote)
								: [{ description: dealerNote }];
							handleChange("dealerNotes", tempNote);

							l.dateGenerated = todayTime;
							l.insertedOn = today;
							l.updatedOn = today;
							l.dealerNotes = tempNote;
						}
						saveLead(l).then((res) => {
							if (l.leadID == null) {
								setLeadSource((prev) => {
									return [res.data.content, ...prev];
								});
							} else {
								setLeadSource((prev) => {
									return prev.map((row) => (row.leadID === l.leadID ? l : row));
								});
							}
							toggle();
							history.push(PATHS.CUSTOMER_LIST);
						});
					}}
				>
					<i className="nc-icon nc-check-2" /> Save
				</div>
			</>
		);
	};
	return (
		<>
			{lead && Object.keys(lead).length === 0 && (
				<Row className="pb-2 pt-3 text-center ">
					<CardTitle>
						<h2>Add Lead</h2>
					</CardTitle>
				</Row>
			)}
			<Row className="justify-content-center">
				<div className="col-xl-2">
					<Card className="cursor-pointer">
						<CardBody
							onClick={() => xpnToggle(xpnModal, setXpnModal)}
							className="text-center"
						>
							<img src={Experian} alt="experian" className="rounded" />
							Score: {scoreHandler(lead?.xpnScore)}
						</CardBody>
					</Card>
				</div>
				<div className="col-xl-2">
					<Card className="cursor-pointer">
						<CardBody
							onClick={() => tuToggle(tuModal, setTuModal)}
							className="text-center"
						>
							<img src={Transunion} alt="transunion" className="rounded" />
							Score: {scoreHandler(lead?.tuScore)}
						</CardBody>
					</Card>
				</div>
				<div className="col-xl-2">
					<Card className="cursor-pointer">
						<CardBody
							onClick={() => efxToggle(efxModal, setEfxModal)}
							className="text-center"
						>
							<img src={Equifax} alt="equifax" className="rounded" />
							Score: {scoreHandler(lead?.efxScore)}
						</CardBody>
					</Card>
				</div>

				<PreScreenModals
					xpnToggle={xpnToggle}
					xpnModal={xpnModal}
					Credit={Credit}
					lead={lead}
					tuModal={tuModal}
					efxModal={efxModal}
					tuToggle={tuToggle}
					efxToggle={efxToggle}
				/>
				{!isCreditSignup ? (
					<div className="col-xl-4">
						<Card className="cursor-pointer">
							<a
								href="https://700credit.com/dealerclick"
								target="_blank"
								rel="noopener noreferrer"
								className=""
							>
								<CardBody>
									<img src={Credit} alt="700credit" className="rounded" />
									<div className="p text-center">Sign Up</div>
								</CardBody>
							</a>
						</Card>
					</div>
				) : (
					" "
				)}
			</Row>
			<Row>
				<SelectorElement
					disableValidation={true}
					value={status}
					name="LeadStatus"
					label="Status"
					onChange={(e) => setStatus(Number(e.target.value))}
					options={OnlineLeadStatus}
				/>
				<SelectorElement
					disableValidation={true}
					value={currentLead?.salesPersonID}
					name="salesman"
					label="Assign Salesman"
					onChange={(e) =>
						handleChange("salesPersonID", Number(e.target.value))
					}
					options={salesPeople}
				/>
				<div>
					<div>   </div>
					<Button
						className="mr-1"
						color="primary"
						onClick={() => {
							setShowNote(true);
						}}
						size="lg"
					>
						Dealer Notes
					</Button>
				</div>
			</Row>
			<FormProvider {...methods}>
				<InputWrapper
					formTitle="Person"
					inputComponents={[
						<PersonalData
							currentLead={currentLead}
							setCurrentLead={setCurrentLead}
							methods={methods}
							handleChange={handleChange}
						/>,
					]}
				/>
				<br />
				<InputWrapper
					formTitle="Current Auto Loans"
					inputComponents={[
						<LiabilityTab
							liabilities={liabilities}
							editLiabilities={setLiabilities}
							custRecNum={lead?.leadID}
							contactType="Lead"
						/>,
					]}
				/>
				<br />
				<InputWrapper
					formTitle="Looking For"
					inputComponents={[
						<LookingForData
							currentLead={currentLead}
							handleChange={handleChange}
							methods={methods}
							yearList={yearList}
							makeList={makeList}
							modelList={modelList}
						/>,
					]}
				/>
				<br />
				<InputWrapper
					formTitle="Vehicle"
					inputComponents={[
						<VehicleData setIncID={setIncID} leadVehicle={leadVehicle} />,
					]}
				/>
				<br />
				<InputWrapper
					formTitle="Trade Info"
					inputComponents={[
						<LeadTradeInfo
							currentLead={currentLead}
							handleChange={handleChange}
							methods={methods}
							yearList={yearList}
							makeList={makeList}
							modelList={modelList}
						/>,
					]}
				/>
				<br />

				<InputWrapper
					formTitle="Lead Note"
					inputComponents={[
						<MessageData currentLead={currentLead} htmlMessage={htmlMessage} />,
					]}
				/>
				<br />
				{/* <InputWrapper formTitle="Dealer Notes" inputComponents={leadNote} />
				<br />
				<NoteComponent
					notes={dealerNote}
					editNotes={setDealerNote}
					saveNotes={shouldSaveNote}
				/> */}
				<br />
				<ProfilePicture
					dealerID={dealerID}
					locationID={locationID}
					lead={lead}
				/>
				<DeleteLeadButton IDs={lead?.leadID} toggle={toggle} />
				<LeadSaveButton />
				<div>{lead?.leadID}</div>
			</FormProvider>
			<ChildrenModal
				size="xl"
				modal={showNote}
				toggle={NoteToggle}
				modalTitle="Dealer Notes"
			>
				{/* ({ notes, editNotes, disableAddAndSave, saveNotes }) */}
				<NoteComponent
					notes={dealerNote}
					editNotes={setDealerNote}
					disableAddAndSave={false}
					saveNotes={shouldSaveNote}
				/>
			</ChildrenModal>
		</>
	);
};

export default OnlineLeadDetails;
